import appStore from '../utils/state';
import gsap from 'gsap';
import isTailwindBreakpoint from '../utils/isTailwindBreakpoint';

export default class SearchButton extends HTMLElement {
  private button: HTMLButtonElement | null = null;

  private onClickBound = this.onClick.bind(this);

  private unsubscribeFromSearchState: (() => void) | null = null;

  private onSearchStateChangedBound = this.onSearchStateChange.bind(this);

  private searchShowTl: gsap.core.Timeline | null = null;
  private searchHideTl: gsap.core.Timeline | null = null;

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.button = this.querySelector('[data-search-button-ref="button"]');

    this.addEventListeners();
    this.subscribe();
  }

  addEventListeners(): void {
    if (this.button) {
      this.button.addEventListener('click', this.onClickBound);
    }
  }

  removeEventListeners(): void {
    if (this.button) {
      this.button.removeEventListener('click', this.onClickBound);
    }
  }

  subscribe() {
    this.unsubscribeFromSearchState = appStore.subscribeKey('isSearchModalOpen', this.onSearchStateChangedBound);
  }

  unsubscribe() {
    if (this.unsubscribeFromSearchState) {
      this.unsubscribeFromSearchState();
      this.unsubscribeFromSearchState = null;
    }
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    appStore.actions.updateSearchValue(input.value);
  }

  onSearchStateChange(isSearchModalOpen: boolean): void {
    if (isSearchModalOpen) {
      this.onSearchShow();
    } else {
      this.onSearchHide();
    }
  }

  onSearchShow(): void {
    if (this.searchShowTl) {
      this.searchShowTl.kill();
    }

    if (this.searchHideTl) {
      this.searchHideTl.kill();
    }

    this.searchShowTl = gsap.timeline();
    if (isTailwindBreakpoint('lg')) {
      this.searchShowTl.set(
        this.button,
        {
          autoAlpha: 0,
        },
        0,
      );
    }
  }

  onSearchHide(): void {
    if (this.searchHideTl) {
      this.searchHideTl.kill();
    }

    if (this.searchShowTl) {
      this.searchShowTl.kill();
    }

    this.searchHideTl = gsap.timeline();
    this.searchHideTl.set(
      this.button,
      {
        autoAlpha: 1,
      },
      0.6,
    );
  }

  onClick(): void {
    appStore.actions.toggleSearchModal();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
    this.unsubscribe();
  }
}

customElements.define('search-button', SearchButton);
